import React from 'react';
import { Link } from 'react-router-dom';
import { cx } from './ui/utils';

const Breadcrumbs = ({
  items = [],
  className = '',
  linkClassName = '',
  itemClassName = '',
  separatorClassName = '',
}) => {
  if (!items.length) return null;
  return (
    <nav
      aria-label="Breadcrumb"
      className={cx('flex flex-wrap items-center gap-2 text-[11px] uppercase tracking-[0.25em]', className)}
    >
      {items.map((item, idx) => (
        <span key={`${item.label}-${idx}`} className="flex items-center gap-2">
          {item.to ? (
            <Link to={item.to} className={cx('transition hover:underline', linkClassName)}>
              {item.label}
            </Link>
          ) : (
            <span className={cx(itemClassName)}>{item.label}</span>
          )}
          {idx < items.length - 1 ? (
            <span className={cx('opacity-60', separatorClassName)}>/</span>
          ) : null}
        </span>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
